import React, { useState, useRef } from 'react';
import emailjs from '@emailjs/browser';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaFacebookF, FaInstagram } from 'react-icons/fa';
import './Contact.css';

const Contact = () => {
  const formRef = useRef();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  const [formStatus, setFormStatus] = useState({
    submitted: false,
    success: false,
    message: '',
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setFormStatus({ submitted: false, success: false, message: '' });

    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        formRef.current,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        () => {
          setFormStatus({
            submitted: true,
            success: true,
            message: 'Hvala na poruci! Kontaktirat ćemo vas uskoro.',
          });
          setFormData({ name: '', email: '', subject: '', message: '' });
        },
        (error) => {
          console.error('EmailJS error:', error);
          setFormStatus({
            submitted: true,
            success: false,
            message: 'Greška pri slanju poruke. Molimo pokušajte ponovo ili nas kontaktirajte telefonom.',
          });
        }
      )
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <section id="contact" className="contact-section">
      <div className="container">
        <h2 className="section-title">Kontakt</h2>

        <div className="contact-content">
          <div className="contact-info">
            <h3>Kontakt informacije</h3>

            <div className="contact-item">
              <FaPhone className="contact-icon" />
              <div>
                <h4>Telefon</h4>
                <p>+387 61 289290</p>
              </div>
            </div>

            <div className="contact-item">
              <FaEnvelope className="contact-icon" />
              <div>
                <h4>Email</h4>
                <p><a href="mailto:info@odmaralistehana.ba">info@odmaralistehana.ba</a></p>
              </div>
            </div>

            <div className="contact-item">
              <FaMapMarkerAlt className="contact-icon" />
              <div>
                <h4>Adresa</h4>
                <p>Piskavica bb, 75000 Tuzla</p>
                <p>Sjedište firme: Franje Markovića 10, Tuzla</p>
              </div>
            </div>

            <div className="contact-item">
              <div className="social-icons">
                <a
                  href="https://www.facebook.com/profile.php?id=61576862631693"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link-contact"
                >
                  <FaFacebookF />
                </a>
                <a
                  href="https://www.instagram.com/odmaralistehana"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link-contact"
                >
                  <FaInstagram />
                </a>
              </div>
              <div>
                <h4>Društvene mreže</h4>
                <p>Pratite nas na društvenim mrežama</p>
              </div>
            </div>

            <div className="business-info">
              <h4>Poslovne informacije</h4>
              <p>Obrtnička djelatnost „Odmaralište Hana", vl. Hadzic Edin, Tuzla</p>
              <p>JIP: 4311995490005</p>
              <p>Broj računa: 1941041192000163, ProCredit Banka</p>
            </div>
          </div>

          <div className="contact-form-container">
            <h3>Pošaljite nam poruku</h3>

            {formStatus.submitted && (
              <div className={`form-message ${formStatus.success ? 'success' : 'error'}`}>
                {formStatus.message}
              </div>
            )}

            <form className="contact-form" ref={formRef} onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Ime i prezime</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="subject">Naslov</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="message">Poruka</label>
                <textarea
                  id="message"
                  name="message"
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>
              <button type="submit" className="submit-btn" disabled={isSubmitting}>
                {isSubmitting ? 'Šaljem...' : 'Pošalji poruku'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
